//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var myChart = null;
export default {
  name: 'test',
  props: {
    option: Object,
    component: Object
  },
  inject: ["main", "contain"],
  data: function data() {
    return {
      optionsWidth: 400,
      optionsHeight: 400,
      optionssss: {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [820, 932, 901, 934, 1290, 1330, 1320],
          type: 'line'
        }]
      }
    };
  },
  computed: {
    fontSize: function fontSize() {
      return '30px';
    },
    main: function main(newVal) {
      console.log(newVal, '--xxx');
    },
    contain: function contain(newVal) {
      console.log('watch contain-');
    }
  },
  mounted: function mounted() {
    this.init();
    console.log(this, '---option');
  },
  methods: {
    updateData: function updateData() {
      // console.log(this, 'updateData')
      var data = this.main.activeObj.data;
      var _this$component = this.component,
          width = _this$component.width,
          height = _this$component.height;
      this.optionssss.xAxis.data = data.categories;
      this.optionssss.series[0].data = data.series[0].data;
      myChart.setOption(this.optionssss, true);
      console.log(width, this.optionsWidth);

      if (width !== this.optionsWidth || height !== this.optionsHeight) {
        this.optionsHeight = height;
        this.optionsWidth = width;
        myChart.clear();
        myChart.resize();
        myChart.setOption(this.optionssss, true);
      }
    },
    updateChart: function updateChart() {
      console.log('updateChart');
    },
    init: function init() {
      myChart = echarts.init(document.getElementById('lineCharts'));
      var data = this.$attrs.data;
      console.log(data, '==data');
      this.optionssss.xAxis.data = data.categories;
      this.optionssss.series[0].data = data.series[0].data;
      myChart.setOption(this.optionssss, true);
    }
  }
};